<template>
  <div id="CtesStep">
    <v-card elevation="1" class="pa-1 pt-0">
      <div class="d-flex pa-2 pt-1 list-container">
        <div class="w-100 column pa-1">
          <div class="d-flex justify-space-between align-center column-title px-3">
            <div class="d-flex align-center">
              <h1 style="color: black">Detalhes das Entregas</h1>
              <v-divider vertical class="mx-2 my-1"></v-divider>
              <v-label class="pb-0 pt-1 mr-2 font-weight-medium black--text" style="font-size: 14px"
                >{{ filteredCtes.length }} itens</v-label
              >
              <v-checkbox
                v-model="selectAllDeliveries"
                :disabled="filteredCtes.length === 0"
                class="custom-checkbox pa-0 ma-0"
                label="Selecionar todas"
                hide-details
                @change="toggleSelectAllDeliveries(false)"
              ></v-checkbox>
            </div>
          </div>
          <v-divider class="mx-2 my-1"></v-divider>
          <v-expansion-panels class="px-2 py-1 mt-2" accordion>
            <v-expansion-panel class="elevation-1">
              <v-expansion-panel-header color="#f2f2f2" class="px-4">
                <span>Preenchimento em lote</span>
                <template v-slot:actions>
                  <v-icon color="black"> mdi-chevron-down </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="no-custom-input">
                <v-row class="mt-2 pb-1">
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      ref="costFreight"
                      v-model="filters.costFreight"
                      label="Frete embarcador"
                      color="black"
                      v-money="money"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      v-model="filters.accessKeyCte"
                      label="Chave CTE"
                      v-mask="'############################################'"
                      color="black"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4" class="pb-0">
                    <v-menu
                      v-model="isFilterEmissionDateOpen"
                      :close-on-content-click="true"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedDate(filters.emissionDateCte)"
                          label="Data de emissão"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filters.emissionDateCte"
                        :max="filters.deliveryForecast"
                        locale="pt-br"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="4" class="pb-0">
                    <v-menu
                      v-model="isFilterAuthorizationDateOpen"
                      :close-on-content-click="true"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedDate(filters.authorizationDateCte)"
                          label="Data de autorização"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filters.authorizationDateCte"
                        :min="filters.emissionDateCte"
                        locale="pt-br"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="4" class="pb-0">
                    <v-menu
                      v-model="isFilterForecastDateOpen"
                      :close-on-content-click="true"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedDate(filters.deliveryForecast)"
                          label="Data de previsão"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filters.deliveryForecast"
                        :min="filters.authorizationDateCte"
                        locale="pt-br"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-end align-center">
                    <v-btn
                      elevation="2"
                      color="red"
                      class="mx-2 white--text"
                      :disabled="!hasFilters"
                      @click="cleanFilter()"
                    >
                      Limpar dados
                    </v-btn>
                    <v-tooltip :disabled="hasFilters && !selectedDeliveriesIds.length == 0" top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-btn
                            elevation="2"
                            color="green white--text"
                            :disabled="!hasFilters || selectedDeliveriesIds.length == 0"
                            :loading="isLoadingModifications"
                            @click="applyModifications()"
                          >
                            Aplicar
                          </v-btn>
                        </div>
                      </template>
                      <span>{{
                        selectedDeliveriesIds.length == 0 ? 'Selecione as entregas' : 'Preencha os dados'
                      }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div class="d-flex align-center mx-2 my-1"></div>
          <v-text-field
            v-show="ctes.length > 0"
            class="custom-search px-2"
            label="Buscar"
            color="black"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            single-line
            v-model="searchQueryCtes"
            @keydown.enter="filterCtes()"
            @click:prepend-inner="filterCtes()"
          ></v-text-field>
          <div v-if="isCtesLoading || isLoadingModifications" class="px-2">
            <v-progress-linear indeterminate />
          </div>
          <v-card class="px-2" style="box-shadow: none">
            <v-form ref="form" v-model="isValid">
              <v-data-table
                :headers="fileHeaders"
                :items="isLoadingModifications ? [] : paginatedItems"
                :items-per-page="itemsPerPage"
                fixed-header
                :item-key="'deliveryId'"
                height="410"
                @update:items-per-page="changeItems"
                :footer-props="{
                  'items-per-page-options': [7, 10, 20, 30, 50],
                  itemsPerPageText: 'Itens por página'
                }"
                no-data-text="Nenhuma cte encontrada"
              >
                <template v-if="paginatedItems.length > 0" v-slot:[`header.select`]="{}">
                  <v-checkbox
                    hide-details
                    v-model="selectAllOnCurrentPage"
                    class="pa-0 ma-0 ml-6"
                    @change="toggleSelectAllDeliveries(true)"
                  ></v-checkbox>
                </template>
                <template v-slot:[`item.select`]="{ item }">
                  <v-checkbox
                    hide-details
                    v-model="selectedDeliveries[item.deliveryId]"
                    @change="updateSelectXml(item.deliveryId, $event)"
                    class="pa-0 ma-0 ml-6"
                  ></v-checkbox>
                </template>
                <template v-slot:[`item.nameRecipient`]="{ item }">
                  <TruncateDataWithTooltip
                    :data="item.nameRecipient"
                    :lengthDataToTruncate="10"
                  ></TruncateDataWithTooltip>
                </template>
                <template v-slot:[`item.nameSender`]="{ item }">
                  <TruncateDataWithTooltip :data="item.nameSender" :lengthDataToTruncate="10"></TruncateDataWithTooltip>
                </template>
                <template v-slot:[`item.costFreight`]="{ item }">
                  <div class="d-flex align-center" style="width: 106px">
                    <v-text-field
                      v-model="item.costFreight"
                      :key="item.deliveryId + '-costFreight'"
                      class="column-fields mt-2"
                      style="width: auto; height: auto"
                      color="black"
                      outlined
                      dense
                      v-money="money"
                      :rules="fieldTouched ? [rules.hasPrice] : []"
                      @change="markAsModified(item, 'costFreight', true)"
                      :class="
                        modifiedItem(item.deliveryId, 'costFreight')
                          ? 'v-input--is-focused v-input--has-state blue--text'
                          : ''
                      "
                    ></v-text-field>
                  </div>
                </template>
                <template v-slot:[`item.accessKeyCte`]="{ item }">
                  <div class="d-flex align-center" style="width: 189px">
                    <v-text-field
                      v-model="item.accessKeyCte"
                      v-mask="'############################################'"
                      class="column-fields mt-2"
                      style="width: auto; height: auto"
                      color="black"
                      outlined
                      dense
                      :rules="[rules.hasAccessKey]"
                      @change="markAsModified(item, 'accessKeyCte', true)"
                      :class="
                        modifiedItem(item.deliveryId, 'accessKeyCte')
                          ? 'v-input--is-focused v-input--has-state blue--text'
                          : ''
                      "
                    ></v-text-field>
                  </div>
                </template>
                <template v-slot:[`item.emissionDateCte`]="{ item }">
                  <v-menu
                    v-model="isEmissionDateOpen[item.deliveryId]"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="d-flex align-center" style="width: 140px">
                        <v-text-field
                          :value="formattedDate(item.emissionDateCte)"
                          class="column-fields date-field mt-2"
                          prepend-icon="mdi-calendar"
                          color="black"
                          readonly
                          outlined
                          dense
                          :rules="[rules.required]"
                          :class="
                            modifiedItem(item.deliveryId, 'emissionDateCte', true)
                              ? 'v-input--is-focused v-input--has-state blue--text'
                              : ''
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                        </v-text-field>
                      </div>
                    </template>
                    <v-date-picker
                      v-model="item.emissionDateCte"
                      :max="item.deliveryForecast"
                      locale="pt-br"
                      @change="markAsModified(item, 'emissionDateCte', true)"
                    ></v-date-picker>
                  </v-menu>
                </template>
                <template v-slot:[`item.authorizationDateCte`]="{ item }">
                  <v-menu
                    v-model="isAuthDateOpen[item.deliveryId]"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="d-flex align-center" style="width: 140px">
                        <v-text-field
                          :value="formattedDate(item.authorizationDateCte)"
                          prepend-icon="mdi-calendar"
                          class="column-fields date-field mt-2"
                          color="black"
                          readonly
                          outlined
                          dense
                          :rules="[rules.required]"
                          v-bind="attrs"
                          v-on="on"
                          :class="
                            modifiedItem(item.deliveryId, 'authorizationDateCte')
                              ? 'v-input--is-focused v-input--has-state blue--text'
                              : ''
                          "
                        ></v-text-field>
                      </div>
                    </template>
                    <v-date-picker
                      v-model="item.authorizationDateCte"
                      :min="item.emissionDateCte"
                      locale="pt-br"
                      @change="markAsModified(item, 'authorizationDateCte', true)"
                    ></v-date-picker>
                  </v-menu>
                </template>
                <template v-slot:[`item.deliveryForecast`]="{ item }">
                  <v-menu
                    v-model="isForecastDateOpen[item.deliveryId]"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="d-flex align-center" style="width: 140px">
                        <v-text-field
                          :value="formattedDate(item.deliveryForecast)"
                          prepend-icon="mdi-calendar"
                          class="column-fields date-field mt-2"
                          color="black"
                          readonly
                          outlined
                          dense
                          :rules="[rules.required]"
                          :class="
                            modifiedItem(item.deliveryId, 'deliveryForecast')
                              ? 'v-input--is-focused v-input--has-state blue--text'
                              : ''
                          "
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </div>
                    </template>
                    <v-date-picker
                      v-model="item.deliveryForecast"
                      :min="item.authorizationDateCte"
                      locale="pt-br"
                      @change="markAsModified(item, 'deliveryForecast', true)"
                    ></v-date-picker>
                  </v-menu>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <div class="d-flex justify-center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon dark @click="OpenDeliveryDetails(item)">
                          <ViewSVG />
                        </v-btn>
                      </template>
                      <span>Detalhes</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
              <v-pagination v-model="currentPage" :length="pageCount" :total-visible="7"></v-pagination>
            </v-form>
          </v-card>
          <div class="px-2 mt-2"></div>
        </div>
      </div>
    </v-card>
    <confirm-dialog
      :isOpen="isOpenConfirmationComputed"
      :title="titleConfirmation"
      :body-text="bodyText"
      @confirmClick="createDetailsDeliveries"
      @cancelClick="cancel"
    />
    <delivery-details-dialog
      :isOpen="isOpenDeliveryDetails"
      :item="deliveryDetails"
      @confirmClick="confirmClick"
      @cancelClick="isOpenDeliveryDetails = false"
    />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import ConfirmDialog from '@/components/ConfirmDialog';
import DeliveryDetailsDialog from '@/components/ManualBoardingImport/Stepper/Step3/DeliveryDetailsDialog.vue';
import MessagesError from '@/components/MessagesError.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { VMoney } from 'v-money';
import maskPrice from '@/utils/maskPrice';
import maskWeight from '@/utils/maskWeight';
import ViewSVG from '@/assets/img/view.svg';
import { debounce } from 'lodash';

export default {
  name: 'CtesStep',
  components: {
    ConfirmDialog,
    DeliveryDetailsDialog,
    MessagesError,
    TruncateDataWithTooltip,
    ViewSVG
  },
  props: {
    isOpenConfirmation: {
      type: Boolean,
      default: false
    }
  },
  directives: { money: VMoney },
  data: () => ({
    originalCtes: [],
    deliveryIdsWithNullEmission: [],
    filters: {
      costFreight: null,
      accessKeyCte: null,
      emissionDateCte: null,
      authorizationDateCte: null,
      deliveryForecast: null
    },
    bodyText: '',
    isValid: false,
    isImportsLoading: false,
    isUnallocatedLoading: false,
    isOpenDeliveryDetails: false,
    isLoadingModifications: false,
    deliveryDetails: {},
    isFilterEmissionDateOpen: false,
    isFilterAuthorizationDateOpen: false,
    isFilterForecastDateOpen: false,
    isEmissionDateOpen: {},
    isAuthDateOpen: {},
    isForecastDateOpen: {},
    hasInteractedWithFreight: {},
    isCtesLoading: false,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    },
    searchQueryCtes: '',
    errors: [],
    errorsType: 'error',
    error500: null,
    ctes: [],
    filteredCtes: [],
    modifiedItems: {},
    selectedDeliveries: {},
    fieldTouched: false,
    progress: 0,
    batchSize: 50,
    selectAllDeliveries: false,
    selectAllOnCurrentPage: false,
    itemsPerPage: 7,
    currentPage: 1
  }),
  async mounted() {
    await this.fetchCtes();
    this.checkAndEmit();
    window.addEventListener('resize', this.truncateLimit);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.truncateLimit);
  },
  watch: {
    currentPage: {
      handler() {
        const modifiedDeliveryIds = Object.keys(this.modifiedItems);
        if (modifiedDeliveryIds.length === 0) {
          this.fieldTouched = false;
        } else {
          setTimeout(() => {
            this.validationForm();
          }, 0);
        }
      }
    },
    paginatedItems() {
      this.updateSelectAllState();
      this.updateSelectAllOnCurrentPageState();
    },
    selectedDeliveries: {
      handler() {
        this.updateSelectAllOnCurrentPageState();
      },
      deep: true
    },
    searchQueryCtes: {
      handler(value) {
        if (value === '') {
          this.filteredCtes = this.ctes;
        }
        if (this.selectAllDeliveries) {
          this.selectedDeliveries = {};
          this.selectAllDeliveries = true;
          this.toggleSelectAllDeliveries(false);
          this.validationForm();
        }
      }
    }
  },
  computed: {
    ...mapGetters('ImportManualDeliveryStore', ['getCtes']),
    parameterID() {
      return this.$route.params.id;
    },
    isOpenConfirmationComputed: {
      get() {
        return this.isOpenConfirmation;
      },
      set(value) {
        this.$emit('update:isOpenConfirmation', value);
      }
    },
    rules() {
      return {
        required: (value) => !!value || 'Campo obrigatório!',
        hasAccessKey: (value) => {
          if (!value) {
            return true;
          }
          return value.length === 44 || 'A chave CTe deve ter 44 caracteres!';
        },
        hasPrice: (value) => {
          if (!value) {
            return true;
          }
          return value != 'R$ 0,00' || 'Campo obrigatório!';
        }
      };
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredCtes.slice(start, end);
    },
    pageCount() {
      return Math.ceil(this.filteredCtes.length / this.itemsPerPage);
    },
    hasFilters() {
      if (
        this.filters.costFreight !== 'R$ 0,00' ||
        this.filters.accessKeyCte ||
        this.filters.emissionDateCte ||
        this.filters.authorizationDateCte ||
        this.filters.deliveryForecast
      ) {
        return true;
      }
      return false;
    },
    fileHeaders() {
      return [
        {
          value: 'select',
          text: '',
          sortable: false
        },
        {
          text: 'ENTREGA',
          value: 'deliveryNumber'
        },
        {
          text: 'DESTINATÁRIO',
          value: 'nameRecipient'
        },
        {
          text: 'REMETENTE',
          value: 'nameSender'
        },
        { text: 'FRETE EMBARCADOR', value: 'costFreight' },
        { text: 'CHAVE CTE', value: 'accessKeyCte' },
        { text: 'DATA DE EMISSÃO', value: 'emissionDateCte' },
        { text: 'DATA DE AUTORIZAÇÃO', value: 'authorizationDateCte' },
        { text: 'DATA DE PREVISÃO', value: 'deliveryForecast' },
        { text: 'AÇÕES', value: 'actions', sortable: false }
      ];
    },
    titleConfirmation() {
      return 'Confirmar detalhes das entrega(s)';
    },
    tableHeight() {
      return '410';
    },
    selectedDeliveriesIds() {
      return Object.keys(this.selectedDeliveries).filter((id) => this.selectedDeliveries[id]);
    }
  },
  methods: {
    ...mapActions('SidebarStore', ['changeCollapse']),
    ...mapActions('ImportManualDeliveryStore', ['getAllCtes', 'createDeliveriesDetailsData']),
    ...mapMutations('ImportManualDeliveryStore', ['setCtes']),

    async fetchCtes(setModified = false) {
      this.isCtesLoading = true;
      try {
        const response = await this.getAllCtes(this.parameterID);
        const ctes = response.map((cte) => {
          if (cte.deliveryForecast === '0001-01-01T00:00:00' || !cte.deliveryForecast) {
            cte.deliveryForecast = null;
          } else {
            cte.deliveryForecast = cte.deliveryForecast.slice(0, 10);
          }

          if (!cte.emissionDateCte || cte.emissionDateCte.length < 10) {
            cte.emissionDateCte = null;
          } else {
            cte.emissionDateCte = cte.emissionDateCte.slice(0, 10);
          }

          if (cte.authorizationDateCte && cte.authorizationDateCte.length >= 10) {
            cte.authorizationDateCte = cte.authorizationDateCte.slice(0, 10);
          }
          cte.costFreight = this.transformPrice(cte.costFreight || 0);
          return cte;
        });

        this.setCtes(ctes);
        if (setModified) {
          const savedCtes = JSON.parse(localStorage.getItem('ctes')) || [];
          const mergedCtes = [...ctes];
          savedCtes.forEach((savedCte) => {
            const index = mergedCtes.findIndex((cte) => cte.deliveryId === savedCte.deliveryId);
            if (index !== -1) {
              mergedCtes[index] = { ...mergedCtes[index], ...savedCte };
            } else {
              mergedCtes.push(savedCte);
            }
          });
          this.ctes = mergedCtes;
        } else {
          this.ctes = JSON.parse(JSON.stringify(ctes));
        }
        this.filteredCtes = [...this.ctes];
      } catch (err) {
        console.error(err);
      } finally {
        this.isCtesLoading = false;
      }
    },
    cleanFilter() {
      this.filters = {
        costFreigh: 0,
        accessKeyCte: null,
        emissionDateCte: null,
        authorizationDateCte: null,
        deliveryForecast: null
      };
      if (this.$refs.costFreight) {
        this.$refs.costFreight.$el.getElementsByTagName('input')[0].value = 0;
      }
    },
    filterCtes() {
      this.isCtesLoading = true;
      this.currentPage = 1;
      const query = this.searchQueryCtes ? this.searchQueryCtes.toLowerCase() : '';
      const queryNormalized = query.replace(/[^\d]/g, '');
      const normalizeValue = (value) => {
        return value ? value.replace(/[^\d]/g, '') : '';
      };

      this.filteredCtes = this.ctes.filter((cte) => {
        return (
          (cte.deliveryNumber && cte.deliveryNumber.toString().toLowerCase().includes(query)) ||
          (cte.nameSender && cte.nameSender.toLowerCase().includes(query)) ||
          (cte.nameRecipient && cte.nameRecipient.toLowerCase().includes(query)) ||
          (cte.costFreight &&
            queryNormalized &&
            normalizeValue(maskWeight(cte.costFreight)).includes(queryNormalized)) || // Check if queryNormalized is not empty
          (cte.emissionDateCte && this.formattedDate(cte.emissionDateCte).toLowerCase().includes(query)) ||
          (cte.authorizationDateCte && this.formattedDate(cte.authorizationDateCte).toLowerCase().includes(query)) ||
          (cte.deliveryForecast && this.formattedDate(cte.deliveryForecast).toLowerCase().includes(query))
        );
      });

      if (this.selectAllDeliveries) {
        this.selectedDeliveries = {};
        this.toggleSelectAllDeliveries();
      }
      this.isCtesLoading = false;
    },
    applyModifications() {
      this.isLoadingModifications = true;
      const totalCtes = this.filteredCtes.length;
      let processedCtes = 0;

      const processBatch = (startIndex) => {
        return new Promise((resolve) => {
          requestAnimationFrame(() => {
            const endIndex = Math.min(startIndex + this.batchSize, totalCtes);

            for (let i = startIndex; i < endIndex; i++) {
              const cte = this.filteredCtes[i];
              if (this.selectedDeliveriesIds.includes(cte.deliveryId)) {
                this.applySingleModification(cte);
              }
              processedCtes++;
            }
            this.progress = processedCtes / totalCtes;
            this.updateCtes();
            if (endIndex < totalCtes) {
              resolve(processBatch(endIndex));
            } else {
              this.$nextTick(() => {
                this.isLoadingModifications = false;
                setTimeout(() => {
                  this.validationForm();
                  this.checkAndEmit();
                }, 0);
                resolve();
              });
            }
          });
        });
      };

      processBatch(0).catch((error) => {
        console.error('Erro ao aplicar as modificações:', error);
        this.isLoadingModifications = false;
      });
    },
    updateCtes() {
      this.filteredCtes.forEach((filteredCte) => {
        this.ctes.forEach((cte, index) => {
          if (cte.deliveryId === filteredCte.deliveryId) {
            this.$set(this.ctes, index, { ...filteredCte });
          }
        });
      });
    },
    applySingleModification(cte) {
      let modified = false;
      if (this.filters.costFreight != 'R$ 0,00') {
        cte.costFreight = this.filters.costFreight;
        this.markAsModified(cte, 'costFreight', false);
        modified = true;
      }
      if (this.filters.accessKeyCte != null) {
        cte.accessKeyCte = this.filters.accessKeyCte;
        this.markAsModified(cte, 'accessKeyCte', false);
        modified = true;
      }
      if (this.filters.emissionDateCte != null) {
        cte.emissionDateCte = this.filters.emissionDateCte;
        this.markAsModified(cte, 'emissionDateCte', false);
        modified = true;
      }
      if (this.filters.authorizationDateCte != null) {
        cte.authorizationDateCte = this.filters.authorizationDateCte;
        this.markAsModified(cte, 'authorizationDateCte', false);
        modified = true;
      }
      if (this.filters.deliveryForecast != null) {
        cte.deliveryForecast = this.filters.deliveryForecast;
        this.markAsModified(cte, 'deliveryForecast', false);
        modified = true;
      }

      if (modified) {
        this.$set(this.filteredCtes, this.filteredCtes.indexOf(cte), { ...cte });
      }
    },
    markAsModified(item, type, validate = true) {
      const isModified = this.isModified(item, type);

      if (!this.modifiedItems[item.deliveryId]) {
        this.$set(this.modifiedItems, item.deliveryId, {});
      }
      this.fieldTouched = true;
      if (isModified) {
        this.$set(this.modifiedItems[item.deliveryId], type, true);
      } else {
        this.$delete(this.modifiedItems[item.deliveryId], type);
        if (Object.keys(this.modifiedItems[item.deliveryId]).length === 0) {
          this.$delete(this.modifiedItems, item.deliveryId);
        }
      }
      if (validate) {
        this.validationForm();
        this.checkAndEmit();
      }
    },
    isModified(item, type) {
      const originalItem = this.getCtes.find((origItem) => origItem.deliveryNumber === item.deliveryNumber);

      if (!originalItem) return false;
      switch (type) {
        case 'costFreight':
          return this.transformPriceToSend(item.costFreight) !== originalItem.costFreight / 100;
        case 'accessKeyCte':
          return item.accessKeyCte ? item.accessKeyCte : null != originalItem.accessKeyCte;
        case 'emissionDateCte':
          return item.emissionDateCte !== originalItem.emissionDateCte;
        case 'authorizationDateCte':
          return item.authorizationDateCte !== originalItem.authorizationDateCte;
        case 'deliveryForecast':
          return item.deliveryForecast !== originalItem.deliveryForecast;
        default:
          return false;
      }
    },
    toggleSelectAllDeliveries(isPageSpecific) {
      if (isPageSpecific) {
        const selectAll = this.selectAllOnCurrentPage;
        this.paginatedItems.forEach((item) => {
          this.$set(this.selectedDeliveries, item.deliveryId, selectAll);
        });
      } else {
        const selectAll = this.selectAllDeliveries;
        this.filteredCtes.forEach((item) => {
          this.$set(this.selectedDeliveries, item.deliveryId, selectAll);
        });
        const totalSelectableNfes = this.filteredCtes.length;
        const selectedCount = Object.keys(this.selectedDeliveries).filter((id) => this.selectedDeliveries[id]).length;
        if (totalSelectableNfes > 0 && selectedCount === totalSelectableNfes) {
          this.selectAllDeliveries = true;
        } else {
          this.selectAllDeliveries = false;
        }
      }
    },
    updateSelectAllOnCurrentPageState() {
      this.selectAllOnCurrentPage = this.paginatedItems.every((item) => this.selectedDeliveries[item.deliveryId]);
      const totalSelectableNfes = this.filteredCtes.length;
      const selectedCount = Object.keys(this.selectedDeliveries).filter((id) => this.selectedDeliveries[id]).length;
      if (totalSelectableNfes > 0 && selectedCount === totalSelectableNfes) {
        this.selectAllDeliveries = true;
      } else {
        this.selectAllDeliveries = false;
      }
    },
    updateSelectXml(id, event) {
      this.$set(this.selectedDeliveries, id, event);
      if (!event && !this.selectAllOnCurrentPage) {
        this.selectAllDeliveries = false;
      } else {
        const totalSelectableNfes = this.filteredCtes.length;
        const selectedCount = Object.keys(this.selectedDeliveries).filter((id) => this.selectedDeliveries[id]).length;
        if (totalSelectableNfes > 0 && selectedCount === totalSelectableNfes) {
          this.selectAllDeliveries = true;
        } else {
          this.selectAllDeliveries = false;
        }
      }
    },
    updateSelectAllState() {
      this.selectAllOnCurrentPage = this.paginatedItems.every((item) => this.selectedDeliveries[item.deliveryId]);
    },
    async createDetailsDeliveries() {
      this.$emit('isDetailsDeliveriesLoading', true);
      const modifiedDeliveryIds = Object.keys(this.modifiedItems);
      if (modifiedDeliveryIds.length === 0) {
        this.$emit('confirmClick');
        this.$emit('isDetailsDeliveriesLoading', false);
        return;
      }

      localStorage.setItem('modifiedItems', JSON.stringify(this.modifiedItems));
      localStorage.setItem('ctes', JSON.stringify(this.ctes));

      try {
        const modifiedDeliveries = this.ctes.filter((cte) => {
          return modifiedDeliveryIds.includes(cte.deliveryId);
        });
        const invalidDates = modifiedDeliveries.filter((cte) => {
          const emissionDate = new Date(cte.emissionDateCte);
          const deliveryForecast = new Date(cte.deliveryForecast);
          const authorizationDate = new Date(cte.authorizationDateCte);

          return (
            (cte.deliveryForecast && deliveryForecast < emissionDate) ||
            (cte.authorizationDateCte && authorizationDate < emissionDate)
          );
        });

        if (invalidDates.length > 0) {
          const invalidDeliveryNumbers = invalidDates.map((cte) => cte.deliveryNumber).join(', ');
          this.errors = [
            `As entregas têm datas inválidas: ${invalidDeliveryNumbers}. ` +
              'Verifique se as datas de previsão ou autorização estão corretas em relação à data de emissão.'
          ];
          this.errorsType = 'error';
          this.$emit('isDetailsDeliveriesLoading', false);
          return;
        }

        const detailsDeliveries = modifiedDeliveries.map((cte) => {
          return {
            deliveryId: cte.deliveryId,
            deliveryNumber: cte.deliveryNumber,
            cteTempCreateDto: {
              costFreight: this.transformPriceToSend(cte.costFreight),
              accessKeyCte: cte.accessKeyCte || null,
              emissionDateCte: cte.emissionDateCte,
              authorizationDateCte: cte.authorizationDateCte,
              deliveryForecast: cte.deliveryForecast
            }
          };
        });

        let data = {};
        if (detailsDeliveries.length !== 0) {
          data = await this.createDeliveriesDetailsData(detailsDeliveries);
        }

        let setCtes = false;

        if (data.success) {
          this.errors = ['Detalhes das entregas salvos com sucesso!'];
          this.errorsType = 'success';
          localStorage.removeItem('modifiedItems');
          localStorage.removeItem('ctes');
          this.modifiedItems = {};
          this.$emit('confirmClick');
        } else {
          this.errors = data.errors || ['Erro ao salvar os Detalhes das entregas'];
          this.errorsType = 'error';
          const savedModifiedItems = JSON.parse(localStorage.getItem('modifiedItems'));
          this.modifiedItems = savedModifiedItems || this.modifiedItems;
          setCtes = true;
        }

        await this.fetchCtes(setCtes);
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('isDetailsDeliveriesLoading', false);
      }
    },
    modifiedItem(itemDeliveryId, type) {
      return this.modifiedItems[itemDeliveryId] && this.modifiedItems[itemDeliveryId][type];
    },
    async changeItems(itemsPerPage) {
      this.isCtesLoading = true;
      await this.changeItemsPerPage(itemsPerPage);
      setTimeout(() => {
        this.isCtesLoading = false;
      }, 200);
    },
    changeItemsPerPage: debounce(function (itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.currentPage = 1;
      this.toggleSelectAllDeliveries(false);
    }, 200),
    formattedDate(date) {
      const invoiceDate = date;
      if (!invoiceDate) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    transformPriceToSend(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return Number(money);
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    OpenDeliveryDetails(delivery) {
      this.deliveryDetails = delivery;
      this.isOpenDeliveryDetails = true;
    },
    cancel() {
      this.isOpenConfirmationComputed = false;
      this.deliveryDetails = {};
      this.isOpenDeliveryDetails = false;
    },
    confirmClick() {
      this.$emit('confirmClick');
    },
    parseToNumber(value) {
      if (typeof value === 'string') {
        return parseFloat(value.replace('R$', '').replace(',', '.').trim());
      }
      return value;
    },
    checkAndEmit() {
      const hasMissingFields = this.ctes.some(
        ({ costFreight, emissionDateCte, authorizationDateCte, deliveryForecast }) =>
          !costFreight ||
          this.transformPriceToSend(costFreight) == 0 ||
          !emissionDateCte ||
          !authorizationDateCte ||
          !deliveryForecast
      );
      if (hasMissingFields) {
        this.$emit('stepCtesFinished', true, 'Preencha todos os campos obrigatórios!');
        return;
      }
      const modifiedDeliveryNumbers = [];

      this.ctes.forEach((item) => {
        const originalItem = this.getCtes.find((origItem) => origItem.deliveryNumber === item.deliveryNumber);
        if (!originalItem) return;

        const transformedCostFreightItem = this.parseToNumber(originalItem.costFreight);
        const transformedCostFreightOriginal = this.parseToNumber(item.costFreight);
        const hasModification =
          item.accessKeyCte != originalItem.accessKeyCte ||
          transformedCostFreightItem != transformedCostFreightOriginal ||
          item.emissionDateCte != originalItem.emissionDateCte ||
          item.authorizationDateCte != originalItem.authorizationDateCte ||
          item.deliveryForecast != originalItem.deliveryForecast;

        if (hasModification) {
          modifiedDeliveryNumbers.push(item.deliveryNumber);
        }
      });

      if (modifiedDeliveryNumbers.length === 0) {
        this.bodyText = 'Nenhum dado de entrega foi alterado. Deseja Prosseguir?';
        this.$emit('stepCtesFinished', false, '');
        return;
      } else {
        const limitedDeliveryNumbers = modifiedDeliveryNumbers.slice(0, 15);
        this.bodyText = `Salvar alterações na entrega(s): ${limitedDeliveryNumbers.join(', ')}${
          modifiedDeliveryNumbers.length > 15 ? '...' : ''
        }`;
      }

      const allAccessKeyNull = this.ctes.every(({ accessKeyCte }) => !accessKeyCte);
      const hasInvalidAccessKeyLength = this.ctes.some(
        ({ accessKeyCte }) => accessKeyCte && accessKeyCte.length !== 44
      );

      if (hasInvalidAccessKeyLength) {
        this.$emit('stepCtesFinished', true, 'A chave CTe deve ter 44 caracteres.');
        return;
      }

      if (allAccessKeyNull) {
        this.bodyText = 'Desconsiderando todas as chaves CTes. Deseja Prosseguir?';
        this.$emit('stepCtesFinished', false, '');
        return;
      }

      this.$emit('stepCtesFinished', false, '');
    },
    validationForm() {
      if (this.$refs.form) {
        this.$refs.form.validate();
        this.fieldTouched = true;
      }
    },
    async truncateLimit() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1460) this.changeCollapse(true);
    }
  }
};
</script>
<style lang="scss" scoped>
.list-container {
  width: 100%;
  min-height: 638px;
}
.table-container {
  width: 100%;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}
.cte-container {
  width: 100%;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}
.column-title {
  width: 100%;
  text-align: left;
}
.cte-container::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: #f5f5f5;
}
.cte-container::-webkit-scrollbar-track {
  padding-left: 1px;
  padding-right: 1px;
  background-color: #f5f5f5;
}
.cte-container::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
}
.cte-container::-webkit-scrollbar-thumb:hover {
  background-color: #0f426e9d;
}
::v-deep .v-input {
  input {
    max-height: 40px;
    .v-input__slot .v-input__prepend-inner {
      position: relative;
      top: 0px;
    }
  }
  .v-text-field {
    &__slot {
      margin: 0;
      padding: 0;

      input,
      textarea {
        border: none;
        border-radius: none;
        padding: 0 0px;
        box-shadow: none;
        background: none;

        &:focus,
        &:hover {
          background: none;
          border-color: none;
        }
      }

      .v-label {
        position: relative;
        transform: translateY(0px);
        top: auto;
        color: black;
      }
    }
  }
}
::v-deep .no-custom-input .v-input {
  position: relative;

  &--selection-controls {
    margin-top: 5px;
  }

  .v-label {
    font-size: 15px;
    color: $--color-primary;
  }

  input {
    max-height: 50px;
    line-height: 50px !important;
    padding: 0;
  }

  .v-input__slot {
    margin: 0;
    padding: 0;

    &::after,
    &::before {
      display: none !important;
    }
  }

  .v-text-field {
    &__slot {
      margin: 0;
      padding: 0;

      input,
      textarea {
        border: 1px solid transparent;
        border-radius: 5px;
        padding: 0 15px;
        box-shadow: 0 2px 4px rgba(23, 23, 23, 0.18);
        background: $--color-input-disable;

        &:focus,
        &:hover {
          background: transparent;
          border-color: $--color-primary;
        }
      }

      .v-label {
        transform: translateY(-20px);
        top: 0;
      }
    }

    &__details {
      display: none;
    }
  }
}
::v-deep .v-data-table.v-data-table--fixed-header thead th {
  background-color: #e0e0e0 !important;
  border: 1px solid #e0e0e0;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
::v-deep .column-fields {
  .v-input__prepend-outer {
    margin-top: -15px !important;
  }
  .v-input__slot {
    margin: 0;
    height: 30px;

    fieldset {
      height: 38px;
    }
    .v-text-field__slot input {
      height: 30px;
      margin-bottom: 3px;
    }
  }
}
::v-deep .date-field {
  .v-input__slot {
    .v-text-field__slot input {
      padding: 0 4px 0 24px !important;
    }
  }
}
.border-blue {
  border: 2px solid blue;
  border-radius: 4px; /* Optional: for rounded corners */
}
::v-deep .custom-checkbox .v-label {
  font-weight: 500;
  font-size: 14px;
  color: black;
}
</style>
